import { Reducer } from 'redux';
import { IApplication, IUserApplicationsStore, PaymentStatus } from './type';
import { TypesUserApplication } from '../../actions/userApplication/type';

const userApplicationsState: IUserApplicationsStore = {
  applicationActive: undefined,
  loanActive: undefined,

  applications: [],
  loanHistory: [],

  paymentPlan: null,

  customPaymentInfo: undefined,
  paymentLinkId: null,
  cashFreePaymentSession: undefined,

  loanInstallmentsActiveInfo: undefined,

  paymentRequestStatus: {
    status: PaymentStatus.UNDEFINED,
  },

  paymentSubscription: undefined,

  paymentLinks: undefined,

  applicationAgreements: undefined,

  applicationAllAgreements: undefined,

  downloadApplicationAgreements: undefined,

  initEsign: [],

  fullListOfBanks: null,

  listOfLoanPurposes: null,

  listOfStates: null,

  listOfEducations: null,

  listOfMaritalStatuses: null,

  finbitRequest: null,

  verifyBankAccount: null,

  isLoadingApplications: false,
  isLoadedApplications: false,
  isFailedApplications: false,

  isLoadingLoans: false,
  isLoadedLoans: false,
  isFailedLoans: false,

  isFailedCreateApplication: false,

  isPaymentSubscriptionLoaded: false,

  isShowLoader: false,
  isShowAgreementsLoader: false,

  summary: undefined,
};

export const userApplications: Reducer<IUserApplicationsStore> = (
  state = userApplicationsState,
  action
) => {
  switch (action.type) {
    case TypesUserApplication.GET_USER_APPLICATIONS_REQUEST:
      return {
        ...state,

        isLoadingApplications: true,
        isLoadedLoans: false,
        isLoadingLoans: true,
      };

    case TypesUserApplication.GET_USER_APPLICATIONS_SUCCESS: {
      let applicationActive: IApplication = action.data[0];

      return {
        ...state,
        applicationActive,
        applications: action.data,
        isFailedCreateApplication: false,
      };
    }

    case TypesUserApplication.GET_USER_APPLICATIONS_ERROR:
      return {
        ...state,
        ...action.data,
      };

    case TypesUserApplication.GET_USER_LOANS_REQUEST:
      return {
        ...state,
        isLoadedLoans: false,
        isLoadingLoans: true,
      };

    case TypesUserApplication.GET_USER_LOANS_SUCCESS: {
      let loanActive: IApplication = action.data[0];
      return {
        ...state,
        loanHistory: action.data,
        loanActive,

        isLoadingLoans: false,
        isLoadedLoans: true,
      };
    }

    case TypesUserApplication.GET_USER_LOANS_ERROR:
      return {
        ...state,
        isLoadingLoans: false,
        isFailedLoans: true,
        isLoadedLoans: true,
      };

    case TypesUserApplication.GET_USER_LOAN_INFO_REQUEST:
      return {
        ...state,
        isLoadedLoans: false,
        isLoadingLoans: true,
      };

    case TypesUserApplication.GET_USER_LOAN_INFO_SUCCESS: {
      return {
        ...state,
        loanInstallmentsActiveInfo: action.data,

        isLoadingLoans: false,
        isLoadedLoans: true,
      };
    }

    case TypesUserApplication.GET_USER_LOAN_INFO_ERROR:
      return {
        ...state,
        isLoadingLoans: false,
        isFailedLoans: true,
      };

    case TypesUserApplication.POST_CREATE_APPLICATION_SUCCESS: {
      return {
        ...state,
        applicationActive: action.data,
        isFailedCreateApplication: false,
        isPaymentSubscriptionLoaded: false,
      };
    }

    case TypesUserApplication.POST_CREATE_APPLICATION_ERROR: {
      return {
        ...state,
        isFailedCreateApplication: true,
        isPaymentSubscriptionLoaded: false,
      };
    }

    case TypesUserApplication.POST_PAYMENT_APPLICATION_SUCCESS: {
      return {
        ...state,
        loanActive: action.data,
      };
    }

    case TypesUserApplication.POST_CREATE_PAYMENTLINK_REQUEST: {
      return {
        ...state,
        loanActive: action.data,
      };
    }

    case TypesUserApplication.POST_CREATE_PAYMENTLINK_SUCCESS: {
      return {
        ...state,
        loanActive: action.data,
      };
    }

    case TypesUserApplication.POST_CREATE_PAYMENTLINK_ERROR: {
      return {
        ...state,
        loanActive: action.data,
      };
    }

    case TypesUserApplication.GET_ACTIVE_PAYMENTLINK_REQUEST: {
      return {
        ...state,
        paymentLinks: action.data,
      };
    }

    case TypesUserApplication.GET_ACTIVE_PAYMENTLINK_SUCCESS: {
      return {
        ...state,
        paymentLinks: action.data,
      };
    }

    case TypesUserApplication.GET_ACTIVE_PAYMENTLINK_ERROR: {
      return {
        ...state,
        paymentLinks: action.data,
      };
    }

    case TypesUserApplication.GET_LOANS_PAYMENTS_REQUEST: {
      return {
        ...state,

        isLoadingPaymentRequest: true,
        isLoadedPaymentRequest: false,
      };
    }

    case TypesUserApplication.GET_LOANS_PAYMENTS_SUCCESS: {
      return {
        ...state,
        paymentRequestStatus: action.data,

        isLoadingPaymentRequest: false,
        isLoadedPaymentRequest: true,
      };
    }

    case TypesUserApplication.GET_LOANS_PAYMENTS_ERROR: {
      return {
        ...state,
        paymentRequestStatus: action.data,

        isLoadingPaymentRequest: false,
        isFailedPaymentRequest: true,
      };
    }

    case TypesUserApplication.GET_PAYMENT_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        paymentSubscription: action.data,
      };
    }

    case TypesUserApplication.GET_PAYMENT_SUBSCRIPTION_ERROR: {
      return {
        ...state,
        paymentSubscription: action.data,
      };
    }

    case TypesUserApplication.POST_SKIP_PAYMENT_SUBSCRIPTION_REQUEST: {
      return {
        ...state,
        paymentSubscription: { ...state.paymentSubscription, isLoadedPaymentSubscription: true },
        isPaymentSubscriptionLoaded: true,
      };
    }

    case TypesUserApplication.POST_SKIP_PAYMENT_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        paymentSubscription: { ...state.paymentSubscription },
        isPaymentSubscriptionLoaded: false,
      };
    }

    case TypesUserApplication.POST_SKIP_PAYMENT_SUBSCRIPTION_ERROR: {
      return {
        ...state,
        paymentSubscription: { ...state.paymentSubscription },
        isPaymentSubscriptionLoaded: false,
      };
    }

    case TypesUserApplication.GET_APPLICATION_AGREEMENTS_SUCCESS: {
      return {
        ...state,
        applicationAgreements: action.data,
        isPaymentSubscriptionLoaded: false,
      };
    }

    case TypesUserApplication.GET_APPLICATION_AGREEMENTS_ERROR: {
      return {
        ...state,
        applicationAgreements: action.data,
      };
    }

    case TypesUserApplication.GET_CONFIRM_CODE_APPLICATION_SUCCESS: {
      return {
        ...state,
        isShowLoader: false,
      };
    }

    case TypesUserApplication.GET_CONFIRM_CODE_APPLICATION_ERROR: {
      return {
        ...state,
        isShowLoader: false,
      };
    }
    case TypesUserApplication.POST_CONFIRM_CODE_APPLICATION_SUCCESS: {
      return {
        ...state,
        isShowLoader: true,
      };
    }

    case TypesUserApplication.POST_CONFIRM_CODE_APPLICATION_ERROR: {
      return {
        ...state,
        isShowLoader: false,
      };
    }

    case TypesUserApplication.GET_ALL_APPLICATION_AGREEMENTS_SUCCESS: {
      return {
        ...state,
        applicationAllAgreements: action.data,
      };
    }

    case TypesUserApplication.GET_ALL_APPLICATION_AGREEMENTS_ERROR: {
      return {
        ...state,
        applicationAllAgreements: action.data,
      };
    }

    case TypesUserApplication.GET_DOWNLOAD_EXPERIAN_REPORT_REQUEST: {
      return {
        ...state,
        isShowLoader: true,
      };
    }

    case TypesUserApplication.GET_DOWNLOAD_EXPERIAN_REPORT_SUCCESS: {
      return {
        ...state,
        isShowLoader: false,
      };
    }

    case TypesUserApplication.GET_DOWNLOAD_EXPERIAN_REPORT_ERROR: {
      return {
        ...state,
        isShowLoader: false,
      };
    }

    case TypesUserApplication.GET_DOWNLOAD_AGREEMENTS_REQUEST: {
      return {
        ...state,
        isShowAgreementsLoader: true,
      };
    }

    case TypesUserApplication.GET_DOWNLOAD_AGREEMENTS_SUCCESS: {
      return {
        ...state,
        isShowLoader: false,
        downloadApplicationAgreements: action.data,
        isShowAgreementsLoader: false,
      };
    }

    case TypesUserApplication.GET_DOWNLOAD_AGREEMENTS_ERROR: {
      return {
        ...state,
        isShowAgreementsLoader: false,
      };
    }

    case TypesUserApplication.GET_DOWNLOAD_SIGNED_DOCUMENTS_REQUEST: {
      return {
        ...state,
        isShowAgreementsLoader: true,
      };
    }

    case TypesUserApplication.GET_DOWNLOAD_SIGNED_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        downloadApplicationAgreements: action.data,
        isShowAgreementsLoader: false,
      };
    }
    case TypesUserApplication.GET_DOWNLOAD_SIGNED_DOCUMENTS_ERROR: {
      return {
        ...state,
        isShowAgreementsLoader: false,
      };
    }

    case TypesUserApplication.GET_LIST_OF_BANKS_SUCCESS: {
      return {
        ...state,
        fullListOfBanks: action.data,
      };
    }

    case TypesUserApplication.GET_LIST_OF_STATES_SUCCESS: {
      return {
        ...state,
        listOfStates: action.data,
      };
    }

    case TypesUserApplication.GET_LIST_OF_EDUCATION_SUCCESS: {
      return {
        ...state,
        listOfEducations: action.data,
      };
    }

    case TypesUserApplication.GET_LIST_OF_MARITAL_STATUS_SUCCESS: {
      return {
        ...state,
        listOfMaritalStatuses: action.data,
      };
    }

    case TypesUserApplication.GET_LIST_OF_LOAN_PURPOSES_SUCCESS: {
      return {
        ...state,
        listOfLoanPurposes: action.data,
      };
    }

    case TypesUserApplication.POST_FINBIT_REQUEST:
      return {
        ...state,
      };

    case TypesUserApplication.POST_FINBIT_SUCCESS: {
      return {
        ...state,
        finbitRequest: action.data,
      };
    }

    case TypesUserApplication.POST_INIT_ESIGN_SUCCESS: {
      return {
        ...state,
        initEsign: action.data,
      };
    }

    case TypesUserApplication.GET_FINBIT_SUCCESS: {
      return {
        ...state,
        finbitRequest: action.data,
      };
    }

    case TypesUserApplication.GET_FINBIT_ERROR:
      return {
        ...state,
        finbitRequest: action.data,
      };

    case TypesUserApplication.GET_SUMMARY_APPLICATION_SUCCESS: {
      return {
        ...state,
        summary: action.data,
      };
    }

    case TypesUserApplication.GET_SUMMARY_APPLICATION_ERROR:
      return {
        ...state,
        summary: action.data,
      };

    case TypesUserApplication.GET_PAYMENT_PLAN_INFO_REQUEST:
      return {
        ...state,
        isLoadedLoans: false,
        isLoadingLoans: true,
      };

    case TypesUserApplication.GET_PAYMENT_PLAN_INFO_SUCCESS: {
      return {
        ...state,
        paymentPlan: action.data,
      };
    }

    case TypesUserApplication.GET_CUSTOM_PAYMENT_INFO_REQUEST: {
      return {
        ...state,
      };
    }

    case TypesUserApplication.GET_CUSTOM_PAYMENT_INFO_SUCCESS: {
      return {
        ...state,
        customPaymentInfo: action.data,
      };
    }

    case TypesUserApplication.POST_CREATE_CUSTOM_PAYMENT_LINK_REQUEST: {
      return {
        ...state,
        paymentLinkId: null,
      };
    }

    case TypesUserApplication.POST_CREATE_CUSTOM_PAYMENT_LINK_SUCCESS: {
      return {
        ...state,
        paymentLinkId: action.data,
      };
    }

    case TypesUserApplication.GET_CASH_FREE_PAYMENT_SESSION_REQUEST: {
      return {
        ...state,
        cashFreePaymentSession: undefined,
      };
    }

    case TypesUserApplication.GET_CASH_FREE_PAYMENT_SESSION_SUCCESS: {
      return {
        ...state,
        cashFreePaymentSession: action.data,
      };
    }

    default:
      return state;
  }
};
